<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class="flex">
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-select v-model="getYcToolsAiUserList_data.ytabId" clearable placeholder="请选择工具" size="small"
                    style="max-width:150px;" @change="getData">
                    <el-option v-for="(item, index) in getYcToolsAiBaseList_data.data || []" :key="index"
                        :label="item.ytabName" :value="item.ytabId"></el-option>
                </el-select>
                <el-input v-model="getYcToolsAiUserList_data.ytabName" placeholder="请输入标题" clearable size="small"
                    style="max-width:200px;" />
                <el-input v-model="getYcToolsAiUserList_data.userName" placeholder="请输入用户名" clearable size="small"
                    style="max-width:200px;" />
                <el-date-picker v-model="valueDate" size='small' type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
                    value-format="yyyy-MM-dd HH:mm:ss" align="right">
                </el-date-picker>
                <el-button v-click.getYcToolsAiUserList type="primary" icon="el-icon-search" size="small"
                    style="margin-left:10px;">搜索</el-button>
                <el-button @click="Bulksure()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出
                </el-button>
            </el-col>
            <el-col :span="6"> </el-col>
        </el-row>

        <mytable :tableColums="tableColums_getYcToolsAiUserList" api="getYcToolsAiUserList"
            updateapi="updateMicrolectureTypeMain" :height="H - 165">
        </mytable>
        <el-dialog title="详情" :visible.sync="viedoDet" width="88%" :before-close="DeailClose">
            <el-table v-if="detailArr.ycToolsAiUserMsgList" :data="detailArr.ycToolsAiUserMsgList || []" border
                highlight-current-row :header-cell-style="{
                    textAlign: 'center',
                    background: 'rgba(0,170,255,0.5)',
                    color: 'black',
                    border: 'none'
                }" style="width: 100%;margin:12px 0 0 0;">
                <el-table-column type="index" width="50" label="序号" fixed="left">
                </el-table-column>
                <el-table-column prop="ytaumQuestion" label="问题" width="460">
                </el-table-column>
                <el-table-column prop="ytaumThink" label="思考" width="60">
                    <template slot-scope="scope">
                        <div style="width: 100%;height: 100%;" v-html="scope.row.ytaumThink">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ytaumAnswer" label="回答" width="860">
                    <template slot-scope="scope">
                        <div style="width: 100%;height: 100%;" v-html="scope.row.ytaumAnswer">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" width="160">
                </el-table-column>
                <el-table-column prop="a" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.ytaumWordUrl" @click="handleDownload(scope.row)" type="primary"
                            size="small">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%;height: 300px;">
                <div ref="eCharts1" style="width: 80%;height: 100%; margin: 20px auto;"></div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import aplayer from "vue-aplayer";
import echarts from "echarts";
export default {
    components: {
        aplayer
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            valueDate: "",
            examType: "",
            valueDate: "",
            ymtmTimeSubmitStart: "",
            ymtmTimeSubmitEnd: "",
            dtId: "",
            baseUrl: $Api.baseUrl_online,
            audio2: [],
            audioShow: false,
            audio: null,
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: [],
            yatuStatus: "",
            microlectureTitle: "",
            getMicrolectureTypeMainList_data: [],
            theUserProject: "",
            theProjectId: "",
            detailArr: [],
            viedoDet: false,
            mtmId: null,

            tableColums_getYcToolsAiUserList: {
                $selection: false,
                ytabName: "智能工具标题",
                ytabTitleShow: ["对话标题", 240],
                createusername: "创建人",
                createtime: "创建时间",
                $operation: [
                    "操作",
                    100,
                    `@text: 详情#success @click: handelDetail($row)`
                ]
            }
        };
    },

    watch: {},

    methods: {
        timeChange(e) {
            if (e) {
                this.getYcToolsAiUserList_data.dateTimeStart = e[0];
                this.getYcToolsAiUserList_data.dateTimeEnd = e[1];
            } else {
                this.getYcToolsAiUserList_data.dateTimeStart = "";
                this.getYcToolsAiUserList_data.dateTimeEnd = "";
            }
        },
        handleDownload(row) {
            const url = row.ytaumWordUrl;
            const link = document.createElement("a");
            link.href = url;
            link.download = "方案.docx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        theDtChange(e) {
            this.dtId = e;
            this.$refs.cascader.dropDownVisible = false;
            this.getData();
        },

        onEnded() {
            this.audio2 = [];
            this.audioShow = false;
        },
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Bulksure() {
            const bulkdata = {
                projectId: this.theProjectId,
                ytabId: this.getYcToolsAiUserList_data.ytabId,
                ytabName: this.getYcToolsAiUserList_data.ytabName,
                userName: this.getYcToolsAiUserList_data.userName,
                dateTimeStart: this.getYcToolsAiUserList_data.dateTimeStart,
                dateTimeEnd: this.getYcToolsAiUserList_data.dateTimeEnd
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/opportunity/yc-tools-ai-user/exportYcToolsAiUserList",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "用户记录.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        play(row) {
            if (this.audio != null && !this.audio.paused) {
                this.audio.pause();
            }
            if (this.audio == null) {
                this.audio = new Audio();
            }
            this.audio.src = row;
            this.audio.play();
        },
        Preview(url) {
            document.PreviewVideo(url);
        },
        // 图标配置项
        DrawEcharts() {
            console.log(this.$refs.eCharts1);
            this.echartsStr = this.$echarts.init(this.$refs.eCharts1);
            this.echartsStr.setOption({
                darkMode: " auto",
                colorBy: "series",
                color: this.color,
                // backgroundColor: '#100C2A',
                title: {
                    text: "训练分析",
                    left: "3%",
                    top: "3%"
                }, //标题位置

                tooltip: {
                    trigger: "item"
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    right: "3%",
                    top: "3%",
                    data: ["训练分析"]
                },
                radar: {
                    // shape: 'circle',
                    indicator: this.echartsStrValue.data
                },
                series: [
                    {
                        type: "radar",
                        radius: "80%",
                        data: [
                            {
                                value: this.echartsStrValue.xdata,
                                name: "训练分析"
                            }
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });
        },

        handelDetail(row) {
            this.getYcToolsAiUserDetails({ ytauId: row.ytauId }).result(
                res => {
                    console.log(res);
                    if (res.data.data) {
                        this.detailArr = res.data.data;
                        this.viedoDet = true;
                    }
                }
            );
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData();
        },
        getData() {
            this.getYcToolsAiUserList({
                ytabId: this.getYcToolsAiUserList_data.ytabId,
                projectId: this.theProjectId,
                userName: this.getYcToolsAiUserList_data.userName,
                yatbTitle: this.getYcToolsAiUserList_data.yatbTitle
            });
        }
    },

    async created() {

        this.getYcToolsAiBaseList({ pageSize: 0 });
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcToolsAiUserList({ projectId: A.local("$projectId") });

    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/aiTools/aiToolsRecord.vue